
<!-- Start Blog Area -->
<section class="blog-area pt-50 pb-70">

    <div class="container">

        <!-- Section Title -->
        <div class="section-title" *ngFor="let Content of sectionTitle;">
            <h2>{{Content.title}}</h2>
        </div>

        <!-- Blog Posts -->
        <div class="row justify-content-center g-4">

            <div class="col-12 col-sm-6 col-lg-4"
                 *ngFor="let Content of singleBlogPost;">

                <div class="single-blog-post h-100">

                    <!-- Blog Image -->
                    <div class="post-image">

                        <img [src]="Content.imageUrl"
                             [alt]="Content.newsTitle"
                             class="responsive-img">

                    </div>

                    <!-- Blog Content -->
                    <div class="post-content">

                        <h3>{{Content.newsTitle}}</h3>

                        <p>
                            {{Content.newsDesciption}}
                        </p>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>
<!-- End Blog Area -->
